export default "__VITE_ASSET__5390a5bc__"